import React, { Component } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";
import style from "./BillingComponent.module.css";
import { fetchPlanSubOptionLookup } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { checkIfPermitted, Permissions } from "../../../services/RolePermissionService";
import Diagnosis from "./Diagnosis";
//import  PatientInvoiceCash  from "./PatientInvoiceCash";
import { Formik, Field, Form, ErrorMessage } from "formik";
import MediswitchPayload from "../../../utils/MediSwitchPayloadStatic.json";
import infoIcon from '../../../assets/images/info-icon.svg';
import lineTypeClose from '../../../assets/images/line-type-close-icon.svg';
import { Select } from "antd";
import Procedures from "./Procedures";
import swal from "sweetalert";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import * as Yup from "yup";
import { isEmpty, getValWithVAT, formatNumberToCurrency,getValueOfPercent } from "../../../utils/CommonUtil";
import Modifiers from "./Modifiers";
import Medicines from "./Medicines";
import Consumables from "./Consumables";
const { Option } = Select;
//The data for tabs working on this page.
const Tabs = [{
  tabId: 1,
  tabName: "Diagnosis",
  enable: 1
},
{
  tabId: 2,
  tabName: "Procedures",
  enable: 1
},
{
  tabId: 3,
  tabName: "Medicines",
  enable: 1
},
{
  tabId: 4,
  tabName: "Consumables",
  enable: 1
},
{
  tabId: 5,
  tabName: "Modifiers",
  enable: 1
}];

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
    }`;
}

export class BillingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      lineItemsArray: [],
      diagnosis_codes: [],
      diagnosis_string: "",
      subTotal: 0,
      vatPrice: 0,
      grandTotal: 0,
      claimed_amount: 0,
      patient_liable_amount: 0,
      scheme_liable_amount: 0,
      amount_paid: 0,
      balance: 0,
      vat_percent:
        localStorage.getItem("SETTING_INFO") &&
        JSON.parse(localStorage.getItem("SETTING_INFO")).vat_percent,
      line_items_all_selected: 0,
      planSubOptionLookupData: {},
      isModalOpen: false,
      selectedRow: {},
      claimAsAssistant: 0,
      discount:0,
      writeoff_amount:0
    };
    //console.log("paylaod", MediswitchPayload)
  }

  componentDidMount = async () => {

    //console.log("this.props", this.props.state)
    if (this.props.state) {
      if (this.props.state.related_party) {
        await this.props.fetchPlanSubOptionLookup(this.props.state.related_party);
        if (this.props.planSubOptionLookupData && this.props.planSubOptionLookupData.planSubOptionLookup
          && this.props.planSubOptionLookupData.planSubOptionLookup.planSubOption) {
          this.setState({
            planSubOptionLookupData: this.props.planSubOptionLookupData.planSubOptionLookup.planSubOption
          })
        }
      }
      this.setNewState();
    }

  }

  componentDidUpdate = async (prevProps, prevState) => {
    if (prevProps.state.related_party !== this.props.state.related_party) {
      if (this.props.state.related_party) {
        await this.props.fetchPlanSubOptionLookup(this.props.state.related_party);
        if (this.props.planSubOptionLookupData && this.props.planSubOptionLookupData.planSubOptionLookup
          && this.props.planSubOptionLookupData.planSubOptionLookup.planSubOption) {
          this.setState({
            planSubOptionLookupData: this.props.planSubOptionLookupData.planSubOptionLookup.planSubOption
          })
        }
      }
    }
    if((prevProps.state.lineItemsArray !== this.props.state.lineItemsArray )|| 
    (prevProps.state.diagnosis_codes !== this.props.state.diagnosis_codes )||(prevProps.state.discount !==this.props.state.discount)){
      this.setState({
        lineItemsArray: this.props.state.lineItemsArray,
        diagnosis_codes: this.props.state.diagnosis_codes,
        grandTotal: this.props.state.total,
        claimed_amount: this.props.state.claimed_amount,
        patient_liable_amount: this.props.state.patient_liable_amount,
        scheme_liable_amount: this.props.state.scheme_liable_amount,
        amount_paid: this.props.state.amount_paid,
        balance: this.props.state.balance,
        discount:this.props.state.discount,
        writeoff_amount:this.props.state.writeoff_amount
      }, () => {
        this.updateDiagnosisString();
        this.setPrices();
      })
    }

    if((prevProps.state.claimAsAssistant !== this.props.state.claimAsAssistant )){
      this.setState({
        claimAsAssistant: (this.props.state.claimAsAssistant === 1) ? this.props.state.claimAsAssistant : 0
      },()=>{
        this.setPricesForAssistant();
      })
    }
  }

  setNewState = () => {
    let data = this.props.state;
   // console.log("this.props.state", data)
    if (!isEmpty(data)) {
      this.setState({
        lineItemsArray: data.lineItemsArray && data.lineItemsArray.length > 0 ? [...data.lineItemsArray] : [],// [...MediswitchPayload.line_items],
        diagnosis_codes: data.diagnosis_codes && data.diagnosis_codes.length > 0 ? [...data.diagnosis_codes] : [], // [...MediswitchPayload.diagnosis_codes],
        subTotal: data.sub_total,
        vatPrice: data.vat_amount,
        grandTotal: data.total,
        claimed_amount: data.claimed_amount,
        patient_liable_amount: data.patient_liable_amount,
        scheme_liable_amount: data.scheme_liable_amount,
        amount_paid: data.amount_paid,
        balance: data.balance,
        vat_percent: data.vat_percent ? data.vat_percent : this.state.vat_percent,
        claimAsAssistant: data.claimAsAssistant === 1 ? data.claimAsAssistant : 0,
        discount:data.discount,
        writeoff_amount:data.writeoff_amount
      }, () => {
        this.updateDiagnosisString();
        this.setPrices();
      })

    }
  }

  /**
  * This method will be called when tab is changed.
  */
  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  openModal = (data) => {
    this.setState((prevState) => ({
      isModalOpen: !prevState.isModalOpen,
      selectedRow: prevState.isModalOpen === false && data ? data : {}
    }));
  }

  checkValidNumber = (data) => {
    if (!data || data === "NaN") {
      return "0";
    }
    return data;
  }

  handleInputChange = (event, index) => {
    const val = event.target.value;
    const name = event.target.name;
    const list = [...this.state.lineItemsArray];
    list[index][name] = val;
    this.setState({
      lineItemsArray: list,
    }, () => {
      this.setPrices();
    });
  };

  getValWithVAT = (price) => {
    if (price || Number(price) > 0) {
      let vatPrice = (Number(price) * (this.props.vat_percent / 100));
      return (vatPrice + Number(price));
    }
    return 0;
  }

  handleInputQuantityChange = (event, index) => {
    const val = event.target.value;
    const name = event.target.name;
    const list = [...this.state.lineItemsArray];
    list[index][name] = val;

    if (list[index].line_type === "medicine" && list[index].base_price) {

      // add vat price to single exit fee of medicine.
      let totalSingleExitPrice = Number(list[index].base_price) * Number(list[index].quantity);
      let singleExitPriceWithVAT = getValWithVAT(totalSingleExitPrice);
      let markupPercent = list[index].markupPercent ? Number(list[index].markupPercent) : 0;

      //calculating final price value by adding markup percentage
      let fixedFeeWithVAT = list[index].fixedFeeWithVAT ? list[index].fixedFeeWithVAT : 0
      let finalPrice = Number(singleExitPriceWithVAT) + Number(fixedFeeWithVAT);
      let markupValue = markupPercent ? (finalPrice * (markupPercent / 100)) : 0;
      let price = finalPrice + markupValue;
      list[index].price = price ? Number(price.toFixed(2)) : 0;
      list[index].calculatedPrice = price ? Number(price.toFixed(2)) : 0;

    } else if (list[index].base_price) {
      let price = Number(list[index].base_price) * Number(list[index].quantity);
      if(list[index].line_type === "procedure" && (this.state.claimAsAssistant === 0)){
        list[index].price = price ? Number(price.toFixed(2)) : 0;
      }
      list[index].calculatedPrice = price ? Number(price.toFixed(2)) : 0;
    }
    this.setState({
      lineItemsArray: list,
    }, () => {
      this.setPrices();
      // this.props.updateState(this.state);
    });
  }

  setPricesForAssistant = () => {
    let lineItemsArray = [...this.state.lineItemsArray];

    if(lineItemsArray && lineItemsArray.length > 0 &&  this.state.claimAsAssistant === 1){
      lineItemsArray.forEach((item, index)=>{
        if(item.line_type === "procedure" && item.delete !== true){
          lineItemsArray[index].price = 0
        }
      })
    }else if(lineItemsArray && lineItemsArray.length > 0 && this.state.claimAsAssistant === 0){
      lineItemsArray.forEach((item, index)=>{
        if(item.line_type === "procedure" && item.delete !== true){
          lineItemsArray[index].price = lineItemsArray[index].calculatedPrice
        }
      })
    }

    this.setState({
      lineItemsArray: lineItemsArray
    },()=>{
      this.setPrices();
    })

  }

  disableQuantity = (data, index) => {
    let lineItemsArray = [...this.state.lineItemsArray];
    let disableFlag = false;
    if (data.line_type === "modifier") {
      disableFlag = true;
    } else if (data.line_type === "procedure") {
      let modifierPresent = lineItemsArray && lineItemsArray.length > 0 && lineItemsArray.filter((item) => {
        if (item.parentTariffCode) {
          return item.parentTariffCode === data.tariff_code && item.delete !== true ;
        }
      })

      if (modifierPresent && modifierPresent.length > 0) {
        disableFlag = true;
      }

    }
    return disableFlag;
  }

  hideRemove = (data, index) => {
    let lineItemsArray = [...this.state.lineItemsArray];
    let disableFlag = false;

    let modifierPresent = lineItemsArray && lineItemsArray.length > 0 && lineItemsArray.filter((item) => {
      if(item.reference_id && data.reference_id){
        let tariffString = "-" + data.reference_id; 

        return item.reference_id.includes(tariffString) && item.tariff_code !== data.tariff_code  && item.delete !== true ;

      }else if (item.parentTariffCode) {
        return item.parentTariffCode === data.tariff_code && item.delete !== true ;
      }
    })

    if (modifierPresent && modifierPresent.length > 0) {
      disableFlag = true;
    }
    return disableFlag;
  }

  handleInputDocChange = (value, name, index) => {
    const list = [...this.state.lineItemsArray];
    list[index][name] = value;
    this.setState({
      lineItemsArray: list,
    }, () => {
      this.setPrices();
      // this.props.updateState(this.state);
    });
  }

  showAlert = (msg) => {
    swal(msg, {
      className: "logout-swal-modal",
      buttons: "ok",
    });
  }

  updateDiagnosisState = (payload) => {
    let diagnosis_codes = [...this.state.diagnosis_codes];
    const lineItemsArray = [...this.state.lineItemsArray];

    let diagnosis_exist = -1;
    if (diagnosis_codes && diagnosis_codes.length > 0) {
      diagnosis_exist = diagnosis_codes.findIndex((item) => (
        item.diagnosis_code === payload.diagnosis_code && item.delete !== true
      ))
    }

    if (diagnosis_exist === -1) {
      payload.isNewUpload = true;
      diagnosis_codes.push(payload);
      lineItemsArray.length > 0 && lineItemsArray.forEach((item, index) => {
        item.diagnosis_code = item.diagnosis_code.concat(payload.diagnosis_code + ";");
      })

    } else {
      this.showAlert("Diagnosis already added!");
    }

    this.setState({
      diagnosis_codes: diagnosis_codes,
      lineItemsArray: lineItemsArray
    }, () => {
      this.updateDiagnosisString();
      this.props.updateState(this.state);
    })

  }

  updateDiagnosisString = () => {
    let diagnosis_string = "";
    this.state.diagnosis_codes && this.state.diagnosis_codes.length > 0 &&
     this.state.diagnosis_codes.forEach((item) => {
       if(item.delete !== true){
        diagnosis_string = diagnosis_string + item.diagnosis_code + ";"
       }
     })

    this.setState({
      diagnosis_string: diagnosis_string
    })
  }


  updateLineItemsState = (payload) => {

    const lineItemsArray = [...this.state.lineItemsArray];
    if (payload) {
      let line_item_exist = -1;
      if (lineItemsArray && lineItemsArray.length > 0) {
        line_item_exist = lineItemsArray.findIndex((item) => {
          
          //  if (item.line_type === "procedure" || item.line_type === "modifier") {
           if ( item.line_type === "modifier") {
            // if ( item.line_type === "modifier") {  //  item50
            return item.tariff_code === payload.tariff_code && item.delete !== true 
          } else if (item.line_type === "medicine" || item.line_type === "consumable") {
            return item.nappi_code === payload.nappi_code && item.delete !== true
          // }else if( item.line_type === "procedure" ){   //item50
          //   return false;
          }
          return -1;
        })
      }

      // esrdtfghjkl,mnjmbhngfbdsadfghjmk,nmvfdsaxdcvfgbnhjmn
      if (typeof line_item_exist === "number") {
        payload.isNewUpload = true;
        lineItemsArray.push({...payload, isClaimed:1})
      }
      //  else {
      //   this.showAlert("This item is already added!");
      // }

      this.setState({
        lineItemsArray: lineItemsArray
      }, () => {
        this.setPrices();
        // this.props.updateState(this.state);
      })

    }


  }

  updateByMofiersToLineItems = (lineItemsArray) => {

    if (lineItemsArray) {
      this.setState({
        lineItemsArray: lineItemsArray
      }, () => {
        this.setPrices();
        //  this.props.updateState(this.state);
      })

    }


  }

  updateHeightWeight = (data) =>{
    this.props.updateHeightWeight(data);
  }


  handleRemoveClick = (index) => {
    const list = [...this.state.lineItemsArray];

    if(list[index].line_type === "modifier" && list[index].modifierType === "RM" ){
      let parentTariffCode = list[index].parentTariffCode;
      let parentNappiCode = list[index].parentNappiCode;
      let parentIndex = list.findIndex((elem)=>{
        if(elem.nappi_code){
          return (parentNappiCode === elem.nappi_code && elem.delete !== true )
        }else if(elem.tariff_code){
          return ( parentTariffCode === elem.tariff_code && elem.delete !== true)
        }
        })
      if(Number(parentIndex) !== "NaN" && Number(parentIndex) > -1){
        let price = list[parentIndex].calculatedPrice + list[index].base_price;
        if(list[parentIndex].line_type === "procedure" && list[parentIndex].delete !== true && this.state.claimAsAssistant === 0){
          list[parentIndex].price = price ? Number(price.toFixed(2)) : 0;
        }
        list[parentIndex].calculatedPrice = price ? Number(price.toFixed(2)) : 0;
      }
    }

    if (list[index].isNewUpload === true) {
      list.splice(index, 1);
    } else {
      list[index].delete = true;
    }

    this.setState({
      lineItemsArray: list,
    }, () => {
      this.setPrices();
      // this.props.updateState(this.state);
    });
  };

  setPrices = () => {
    console.log("set price")
    let vatPrice = 0;
    let subTotal = 0;
    let grandTotal = 0;
    let claimed_amount = 0;
    let patient_liable_amount = this.state.patient_liable_amount ? Number(this.state.patient_liable_amount) : 0;
    let scheme_liable_amount = this.state.scheme_liable_amount ? Number(this.state.scheme_liable_amount) : 0;
    let amount_paid = this.state.amount_paid ? Number(this.state.amount_paid) : 0;
    let balance = this.state.balance ? Number(this.state.balance) : 0;
    let discountPercentage = this.state.discount ? Number(this.state.discount) : 0;
    console.log("discountpercent", discountPercentage)
    if (this.state.lineItemsArray.length > 0) {
      this.state.lineItemsArray.forEach(element => {
        if (element.delete !== true) {
            subTotal += Number(element.price);
        }
        if(element.delete !== true && element.isClaimed === 1){
          claimed_amount += Number(element.price);
        }
      });

      if (subTotal) {
        grandTotal = Number(subTotal);
      }

      patient_liable_amount = scheme_liable_amount ? Number(grandTotal) - Number(scheme_liable_amount) : Number(grandTotal) ;
      const discountAmount=getValueOfPercent(Number(grandTotal),discountPercentage)
      console.log("discountAmount", discountAmount)
      // balance = Number(patient_liable_amount) - Number(amount_paid);
      balance = (Number(grandTotal) - Number(amount_paid))-discountAmount-Number(this.state.writeoff_amount || 0);
    }
    this.setState({
      grandTotal: grandTotal ? grandTotal.toFixed(2) : 0,
      vatPrice: vatPrice ? vatPrice.toFixed(2) : 0,
      subTotal: subTotal ? subTotal.toFixed(2) : 0,
      claimed_amount: claimed_amount ? claimed_amount.toFixed(2) : 0,
      patient_liable_amount: patient_liable_amount ? patient_liable_amount.toFixed(2) : 0,
      scheme_liable_amount: scheme_liable_amount ? scheme_liable_amount.toFixed(2) : 0,
      amount_paid: amount_paid ? amount_paid.toFixed(2) : 0,
      balance: balance ? balance.toFixed(2) : 0,
    }, () => {
      this.props.updateState(this.state);
    });
  }

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }
  checkData = (data) => {
    if(data === 0){
        return 0;
    }else if (!data) {
      return "Not Available";
    }
    return data;
  }

  detailFormatter = (data) => {
    if (!data) {
        return "Not Available";
    } else {
        return data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
    }
}

getDoctorName = (data) => {
  if (!data) {
    return "Not Available";
  }

  let doctor = this.props.practitionerOptions &&
    this.props.practitionerOptions.find((element, index) => (
      Number(element.practitioner_id) === Number(data)
    ))

  return doctor && doctor.practitioner_name ? doctor.practitioner_name : "Not Available";

}

  handleRemoveDiagnosis = (index) => {
    const list = [...this.state.diagnosis_codes];
    const lineItemsArray = [...this.state.lineItemsArray];

    //list[index].delete = true;
    //list.splice(index, 1);
    let diaCode = list[index].diagnosis_code + ";";
    lineItemsArray.length > 0 && lineItemsArray.forEach((item, index) => {
      if (item.diagnosis_code && item.diagnosis_code.indexOf(diaCode) > -1) {
        item.diagnosis_code = item.diagnosis_code.replace(diaCode, "");
      }
    })

    if (list[index].isNewUpload === true) {
      list.splice(index, 1);
    } else {
      list[index].delete = true;
    }

    this.setState({
      diagnosis_codes: list,
      lineItemsArray: lineItemsArray
    }, () => {
      this.updateDiagnosisString();
      this.setPrices();
    });
  }

  handleSelectAll = (event) => {
    //event.persist();
    const val = event.target.checked;
    const name = event.target.name;
    let lineItemsArray = [...this.state.lineItemsArray];
    if (lineItemsArray.length > 0) {
      lineItemsArray.forEach((item, index) => {
        if (item.line_type !== "modifier" && item.delete !== true) {
          lineItemsArray[index].line_item_checked = val ? 1 : 0;
        }
      })
    }
    this.setState(
      {
        lineItemsArray: lineItemsArray,
        line_items_all_selected: val ? 1 : 0
      }, () => {
        this.props.updateState(this.state);
      });

  };

//   test = (i) => {
// console.log("test index", i)
//   }

  handleInputCheckBoxChange = (event, index) => {
  event.persist();

  setTimeout(() => {   
    console.log("index",event, index)
    const val = event.target.checked;

    const name = event.target.name;
    let lineItemsArray = [...this.state.lineItemsArray];
    console.log("line items base", lineItemsArray)
    if (lineItemsArray.length > 0) {
      lineItemsArray[index].line_item_checked = !val ? 1 : 0;
    }
    this.setState(
      {
        lineItemsArray: lineItemsArray,
        line_items_all_selected: 0
      }, () => {
        this.props.updateState(this.state);
      })}, 500)


  };

  getLineItems = () => {
    return (
      <div className="billing-wrapper">
        <div className="dia-wrapper d-flex justify-content-start">
          <div className="dia-title">
            <h4>Diagnosis:</h4>
          </div>
          <div className="dia-items-list">
            <ul>
              {this.state.diagnosis_codes.length > 0 &&
                this.state.diagnosis_codes.map((element, index) => (

                  !element.delete && (
                    <li key={index} className="dia-item">
                      {element.diagnosis_code}
                      <span className="dia-item-rm">
                        {/* <Link title="Remove" onClick={(e) => this.handleRemoveDiagnosis(index)}><i className="fa fa-times" aria-hidden="true"></i></Link> */}
                        <button
                          type="button"
                          title="Remove" onClick={(e) => this.handleRemoveDiagnosis(index)}
                          className="btn btn-link p-0"
                        >
                         <i className="fa fa-times" aria-hidden="true"></i>
                        </button>
                      </span>
                    </li>)))}
              {(this.state.diagnosis_codes.length === 0 &&
                <li className="dia-item">
                  <span className="dia-item-rm">No diagnosis selected!</span>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="billing-items-table-wrapper">
         <div className="billing-items-table">
          <div className="billing-header d-flex align-items-center justify-content-between">
            <div className="billi ng-col select-col d-flex align-items-center justify-content-center">
              {/* <div className="checkbox">
                <label className="">
                  <input className="check-option" type="checkbox" value="" />
                  <span className="checkmark"></span>
                </label>
              </div> */}
              <div className="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="lineItems"
                  name="lineItems"
                  disabled={this.state.lineItemsArray.length === 0}
                  onChange={this.handleSelectAll}
                  checked={this.state.line_items_all_selected} />
                <label
                  className="custom-control-label"
                  htmlFor="lineItems"
                >
                </label>
              </div>
            </div>

            <div className="billing-col line-col label-header">Line Type</div>
            <div className="billing-col tariff-col label-header">Tariff Code</div>
            <div className="billing-col nappi-col label-header">Nappi Code</div>
            <div className="billing-col desc-col label-header">Description</div>
            <div className="billing-col dia-col label-header">Dia. Code</div>
            <div className="billing-col name-col label-header">Doc./Asst. Name</div>
            <div className="billing-col quantity-col label-header">Quantity</div>
            <div className="billing-col price-col label-header">Price (ZAR) <span>({this.state.vat_percent}% VAT incl.)</span></div>
            <div className="billing-col action-col label-header"></div>
          </div>

          <div className="billing-body">
            {this.state.lineItemsArray && this.state.lineItemsArray.length > 0 &&
              this.state.lineItemsArray.map(
                (element, index) => {
                  return (
                    !element.delete && (
                      <React.Fragment>
                        <div className="billing-row billing-line d-flex align-items-center justify-content-between">
                          {/* <div className="billing-col select-col d-flex align-items-center justify-content-center">
                            <div className="checkbox">
                              <label className="">
                                <input className="check-option" type="checkbox" value="" />
                                <span className="checkmark"></span>
                              </label>
                            </div>
                          </div> */}
{console.log("indexxxxxx", index)}
                          <div
                            className={`custom-control custom-checkbox ${style.recurringWrapper}`}>
                            {element.line_type !== "modifier" && (
                              <React.Fragment>
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id={element.line_type === "medicine" ||
                                    element.line_type === "consumable"  ?
                                    element.nappi_code :index}
                                  name={element.line_type === "medicine" ||
                                    element.line_type === "consumable" ?
                                    element.nappi_code : index}
                                  onChange={(e) =>
                                    this.handleInputCheckBoxChange(
                                      e,
                                      index
                                    )
                                  }
                                  checked={element.line_item_checked === 1}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={element.line_type === "medicine" ||
                                    element.line_type === "consumable" ?
                                    element.nappi_code : index}
                                >
                                </label>
                              </React.Fragment>
                            )}
                          </div>
                          <div className="billing-col line-col">
                            <Field
                              as="select"
                              name="line_type"
                              placeholder="Line Type"
                              maxLength="20"
                              onChange={(e) =>
                                this.handleInputChange(
                                  e,
                                  index
                                )
                              }
                              className={
                                "form-control" +
                                (this.props.errors && this.props.errors.lineItemsArray &&
                                  this.props.errors
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.errors
                                    .lineItemsArray[index]
                                    .line_type && this.props.touched &&
                                  this.props.touched.lineItemsArray &&
                                  this.props.touched
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.touched
                                    .lineItemsArray[index]
                                    .line_type
                                  ? " is-invalid"
                                  : "")
                              }
                              disabled={true}
                              value={
                                this.state
                                  .lineItemsArray[index]
                                  .line_type
                              }
                            >
                              <option value="procedure">Procedure</option>
                              <option value="consumable">Consumable</option>
                              <option value="medicine">Medicine</option>
                              <option value="modifier">Modifier</option>
                            </Field>

                            <ErrorMessage
                              name={`lineItemsArray[${index}].line_type`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="billing-col tariff-col">
                            <Field
                              type="text"
                              name="tariff_code"
                              maxLength="20"
                              placeholder="Tariff Code"
                              disabled={true}
                              onChange={(e) =>
                                this.handleInputChange(
                                  e,
                                  index
                                )
                              }
                              className={
                                "form-control" +
                                (this.props.errors && this.props.errors.lineItemsArray &&
                                  this.props.errors
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.errors
                                    .lineItemsArray[index]
                                    .tariff_code && this.props.touched &&
                                  this.props.touched.lineItemsArray &&
                                  this.props.touched
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.errors
                                    .lineItemsArray[index]
                                    .tariff_code
                                  ? " is-invalid"
                                  : "")
                              }
                              value={
                                this.state
                                  .lineItemsArray[index]
                                  .tariff_code
                              }
                            />

                            <ErrorMessage
                              name={`lineItemsArray[${index}].tariff_code`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="billing-col nappi-col">
                            <Field
                              type="text"
                              name="nappi_code"
                              disabled={true}
                              maxLength="20"
                              placeholder="Nappi Code"
                              onChange={(e) =>
                                this.handleInputChange(
                                  e,
                                  index
                                )
                              }
                              className={
                                "form-control" +
                                (this.props.errors && this.props.errors.lineItemsArray &&
                                  this.props.errors
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.errors
                                    .lineItemsArray[index]
                                    .nappi_code && this.props.touched &&
                                  this.props.touched.lineItemsArray &&
                                  this.props.touched
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.errors
                                    .lineItemsArray[index]
                                    .nappi_code
                                  ? " is-invalid"
                                  : "")
                              }
                              value={
                                this.state
                                  .lineItemsArray[index]
                                  .nappi_code
                              }
                            />

                            <ErrorMessage
                              name={`lineItemsArray[${index}].nappi_code`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="billing-col desc-col">
                            <Field
                              type="text"
                              name="description"
                              //disabled={true}
                              maxLength="70"
                              placeholder="Description"
                              onChange={(e) =>
                                this.handleInputChange(
                                  e,
                                  index
                                )
                              }
                              className={
                                "form-control" +
                                (this.props.errors && this.props.errors.lineItemsArray &&
                                  this.props.errors
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.errors
                                    .lineItemsArray[index]
                                    .description && this.props.touched &&
                                  this.props.touched.lineItemsArray &&
                                  this.props.touched
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.touched
                                    .lineItemsArray[index]
                                    .description
                                  ? " is-invalid"
                                  : "")
                              }
                              value={
                                this.state
                                  .lineItemsArray[index]
                                  .description
                              }
                            />

                            <ErrorMessage
                              name={`lineItemsArray[${index}].description`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="billing-col dia-col">
                            <Field
                              type="text"
                              name="diagnosis_code"
                              disabled={true}
                              placeholder="Diagnosis Code"
                              onChange={(e) =>
                                this.handleInputChange(
                                  e,
                                  index
                                )
                              }
                              className={
                                "form-control" +
                                (this.props.errors && this.props.errors.lineItemsArray &&
                                  this.props.errors
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.errors
                                    .lineItemsArray[index]
                                    .diagnosis_code &&
                                  this.props.touched.lineItemsArray &&
                                  this.props.touched
                                    .lineItemsArray[
                                  index
                                  ] && this.props.touched &&
                                  this.props.touched
                                    .lineItemsArray[index]
                                    .diagnosis_code
                                  ? " is-invalid"
                                  : "")
                              }
                              value={
                                this.state
                                  .lineItemsArray[index]
                                  .diagnosis_code
                              }
                            />

                            <ErrorMessage
                              name={`lineItemsArray[${index}].diagnosis_code`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="billing-col name-col">
                            <Select
                              showSearch
                              allowClear={true}
                              name="doctor_id"
                              placeholder="Search Doctor"
                              optionFilterProp="children"
                              onChange={(value, e) =>
                                this.handleInputDocChange(
                                  value,
                                  "doctor_id",
                                  index
                                )
                              }
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              className={
                                (this.props.errors && this.props.errors.lineItemsArray &&
                                  this.props.errors
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.errors
                                    .lineItemsArray[index]
                                    .doctor_id && this.props.touched &&
                                  this.props.touched.lineItemsArray &&
                                  this.props.touched
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.touched
                                    .lineItemsArray[index]
                                    .doctor_id
                                  ? " is-invalid"
                                  : "")
                              }
                              value={
                                this.state
                                  .lineItemsArray[index]
                                  .doctor_id || undefined
                              }
                            >
                              {this.props.combinedPractitioners &&
                                this.props.combinedPractitioners.map((element, index) => (
                                  <Option key={index} value={element.practitioner_id}>
                                    {element.practitioner_name}
                                  </Option>
                                ))}
                            </Select>

                            <ErrorMessage
                              name={`lineItemsArray[${index}].doctor_id`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="billing-col quantity-col">
                            <Field
                              type="text"
                              name="quantity"
                              maxLength="8"
                              disabled={this.disableQuantity(element, index)}
                              placeholder="Quantity"
                              onChange={(e) =>
                                this.handleInputQuantityChange(
                                  e,
                                  index
                                )
                              }
                              className={
                                "form-control" +
                                (this.props.errors && this.props.errors.lineItemsArray &&
                                  this.props.errors
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.errors
                                    .lineItemsArray[index]
                                    .quantity && this.props.touched &&
                                  this.props.touched.lineItemsArray &&
                                  this.props.touched
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.touched
                                    .lineItemsArray[index]
                                    .quantity
                                  ? " is-invalid"
                                  : "")
                              }
                              value={
                                this.state
                                  .lineItemsArray[index]
                                  .quantity
                              }
                            />

                            <ErrorMessage
                              name={`lineItemsArray[${index}].quantity`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="billing-col price-col">
                            <Field
                              type="text"
                              name="price"
                              disabled={true}
                              placeholder="Price"
                              // onChange={(e) =>
                              //   this.handleInputChange(
                              //     e,
                              //     index
                              //   )
                              // }
                              className={
                                "form-control" +
                                (this.props.errors && this.props.errors.lineItemsArray &&
                                  this.props.errors
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.errors
                                    .lineItemsArray[index]
                                    .price && this.props.touched &&
                                  this.props.touched.lineItemsArray &&
                                  this.props.touched
                                    .lineItemsArray[
                                  index
                                  ] &&
                                  this.props.touched
                                    .lineItemsArray[index]
                                    .price
                                  ? " is-invalid"
                                  : "")
                              }
                              value={
                                formatNumberToCurrency(this.state
                                  .lineItemsArray[index]
                                  .price)
                              }
                            />

                            <ErrorMessage
                              name={`lineItemsArray[${index}].price`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="billing-col action-col">
                            <Link title="Information" onClick={(e) => this.openModal(element)}><img className={"infoicon"} alt="info" src={infoIcon} /></Link>
                            {this.hideRemove(element, index) === false && (
                              <span title="Remove" onClick={(e) => this.handleRemoveClick(index)}>
                                <img className={"lineTypeCloseIcon"} alt="info" src={lineTypeClose} />
                              </span>
                            )}
                          </div>
                        </div>
                      </React.Fragment>
                    )
                  );
                }
              )}
          </div>
        </div>
        </div>
     </div>
    );
  }


  render() {
    const statementsTabData = Tabs.find(
      (element, index) => {
        return element.tabId == this.state.activeTab;
      }
    );
    const data = this.state.selectedRow;
    return (
      <div className={`inventory-audit ${style.billingComponentMainWrapper}`}>
        <div className={`row ${style.reportsTabWrapper}`}>
          <div className="col-md-12">
            <Nav tabs>
              {Tabs &&
                Tabs.map(
                  (element, index) => {
                    if (element.enable === 1) {
                      return (<NavItem key={`${index + 1}`} className={
                        element.tabId === 5 ? "ml-auto" : ""}>
                        <NavLink
                          className={{
                            active: this.state.activeTab === `${index + 1}`,
                          }}
                          onClick={() => {
                            this.toggle(`${index + 1}`);
                          }}
                        >
                          {element.tabName}
                        </NavLink>
                      </NavItem>)
                    }
                  }
                )}
            </Nav>
            <TabContent
              activeTab={this.state.activeTab}
              className={style.tabContentWrapper}
            >
              {Tabs[0].enable === 1 &&
                (<TabPane
                  tabId={`1`}
                  key={`1`}
                  className={style.auditTrailTabContent}
                >
                  {this.state.activeTab == 1 && (
                    // diagnosis list tab
                    <Diagnosis
                    diagnosis_codes={this.state.diagnosis_codes}
                      updateDiagnosisState={this.updateDiagnosisState} />
                  )}
                </TabPane>)}
              <TabPane
                tabId={`2`}
                key={`2`}
                className={style.auditTrailTabContent}
              >
                {this.state.activeTab == 2 && (
                  // Procedure list tab
                  <Procedures
                    claimAsAssistant={this.state.claimAsAssistant}
                    state={this.props.state}
                    diagnosis_string={this.state.diagnosis_string}
                    updateState={this.updateLineItemsState} />
                )}
              </TabPane>
              {Tabs[2].enable === 1 &&
                (<TabPane
                  tabId={`3`}
                  key={`3`}
                  className={style.auditTrailTabContent}
                >
                  {this.state.activeTab == 3 && (
                    // Medicines list tab
                    <Medicines
                    claimAsAssistant={this.state.claimAsAssistant}
                      state={this.props.state}
                      planSubOptionLookupData={this.state.planSubOptionLookupData}
                      diagnosis_string={this.state.diagnosis_string}
                      updateState={this.updateLineItemsState} />
                  )}
                </TabPane>
                )}
              {Tabs[3].enable === 1 &&
                (<TabPane
                  tabId={`4`}
                  key={`4`}
                  className={style.auditTrailTabContent}
                >
                  {this.state.activeTab == 4 && (
                    // Consumables list tab
                    <Consumables
                    claimAsAssistant={this.state.claimAsAssistant}
                      state={this.props.state}
                      planSubOptionLookupData={this.state.planSubOptionLookupData}
                      diagnosis_string={this.state.diagnosis_string}
                      updateState={this.updateLineItemsState} />
                  )}
                </TabPane>
                )}
              {Tabs[4].enable === 1 &&
                (<TabPane
                  tabId={`5`}
                  key={`5`}
                  className={style.auditTrailTabContent}
                >
                  {console.log("inModifire", this.state)}
                  {this.state.activeTab == 5 && (
                    //modifiers tab
                    <Modifiers
                    claimAsAssistant={this.state.claimAsAssistant}
                      state={this.props.state}
                      lineItemsArray={this.state.lineItemsArray}
                      diagnosis_string={this.state.diagnosis_string}
                      updateHeightWeight={this.updateHeightWeight}
                      updateState={this.updateByMofiersToLineItems} />
                  )}
                </TabPane>
                )}

              <hr />

              {this.getLineItems()}
              {(!this.state.lineItemsArray ||
                this.state.lineItemsArray.length === 0) &&
                (
                  <div className="textCenter mt-2">
                    <p>No line items selected!</p>
                  </div>
                )}
              <hr />
              <div className="row">
                <div className="col-12">
                  <div className="billing-total-summary">
                            <p><span>Total invoice (ZAR): </span><span>{formatNumberToCurrency(this.state.grandTotal)}</span></p>
                            {this.props.state.isEstimate !== 1 && (
                                <React.Fragment>
                                {Number(this.props.state.invoice_type_id) === 1 && (<p><span>Claimed amount (ZAR): </span><span>{formatNumberToCurrency(this.state.claimed_amount)}</span></p>)}
                              {Number(this.props.state.invoice_type_id) === 1 && (<p><span>Patient liable amount (ZAR): </span><span>{formatNumberToCurrency(this.state.patient_liable_amount)}</span></p>)}
                              {Number(this.props.state.invoice_type_id) === 1 && (<p><span>Scheme liable amount (ZAR): </span><span>{formatNumberToCurrency(this.state.scheme_liable_amount)}</span></p>)}
                              <p><span>Discount Amount (ZAR): </span><span>{formatNumberToCurrency(getValueOfPercent(this.state.grandTotal,this.state.discount))}</span></p>
                              <p><span>Write Off Amount (ZAR): </span><span>{formatNumberToCurrency(this.state.writeoff_amount)}</span></p>
                              <p><span>Amount paid (ZAR): </span><span>{formatNumberToCurrency(this.state.amount_paid)}</span></p>
                              <p><span>Balance pay (ZAR): </span><span>{formatNumberToCurrency(this.state.balance)}</span></p>
                            </React.Fragment>
                            )}
                   </div>
                </div>
              </div>

            </TabContent>

            <Modal
              isOpen={this.state.isModalOpen}
              toggle={this.openModal}
              className="viewProductDetailsModal"
              centered
            >
              <ModalHeader
                toggle={this.openModal}
                className={style.deleteReasonHeader}
              >
                Information
            </ModalHeader>
              <ModalBody>
                <div className={style.infoWrapper}>
                  <div class="row">

                  <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Line Type</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.detailFormatter(data.line_type)}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Tariff Code</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkData(data.tariff_code)}
                        </div>
                      </div>
                    </div>

                    {data && (data.line_type === "procedure" || data.line_type === "modifier") &&(
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Number of Units</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkData(data.numberOfUnits)}
                        </div>
                      </div>
                    </div>)}


                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Nappi Code</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkData(data.nappi_code)}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Diagnosis Code</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkData(data.diagnosis_code)}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Doc/Assi. Name</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.getDoctorName(data.doctor_id)}
                        </div>
                      </div>
                    </div>

                    {data.line_type === "modifier" && data.parentTariffCode && (
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Parent Tariff Code</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkData(data.parentTariffCode)}
                        </div>
                      </div>
                    </div>)}

                    {data.line_type === "modifier" && data.parentNappiCode && (
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Parent Nappi Code</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkData(data.parentNappiCode)}
                        </div>
                      </div>
                    </div>)}

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Quantity</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkData(data.quantity)}
                        </div>
                      </div>
                    </div>

                    {data && data.line_type === "medicine" &&(
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Days of Therapy</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkData(data.days_of_therapy)}
                        </div>
                      </div>
                    </div>)}

                    {data && (data.line_type === "procedure" || data.line_type === "modifier") &&(
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Treatment Start Time</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkData(data.startdatetime)}
                        </div>
                      </div>
                    </div>)}

                    {data && (data.line_type === "procedure" || data.line_type === "modifier") &&(
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Treatment End Time</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkData(data.enddatetime)}
                        </div>
                      </div>
                    </div>)}

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Amount (ZAR)</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && formatNumberToCurrency(data.price)}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-3">
                          <label>Description</label> :{" "}
                        </div>
                        <div className="col-md-9">
                          {data && this.checkData(data.description)}
                        </div>
                      </div>
                    </div>


                    
                  </div>
                </div>
              </ModalBody>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    planSubOptionLookupData: state.planSubOptionLookup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPlanSubOptionLookup: (patient_id) =>
      dispatch(fetchPlanSubOptionLookup(patient_id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingComponent);
